export const isDraggingSelector = (state) => state.getIn(['app', 'dragging', 'isDragging']);

const getDroppedElementIdsSelector = (state) => state.getIn(['app', 'dragging', 'dropState', 'droppedElementIds']);

export const getDropState = (state, { elementId }) => {
    const droppedElementIds = getDroppedElementIdsSelector(state);

    if (!droppedElementIds || !droppedElementIds.includes(elementId)) return null;

    return state.getIn(['app', 'dragging', 'dropState']);
};

// Attach mode
export const isAttachModeSelector = (state) => state.getIn(['app', 'dragging', 'attachMode']);
export const attachModeTypeSelector = (state) => state.getIn(['app', 'dragging', 'attachModeType']);
export const attachModeHoveredStackSelector = (state) => state.getIn(['app', 'dragging', 'attachModeHoveredStack']);
export const attachModeHoveredElementIdSelector = (state) =>
    state.getIn(['app', 'dragging', 'attachModeHoveredElementId']);
